"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

var _MovingPage = _interopRequireDefault(require("../MovingPage"));

function _default(props) {
  return function () {
    return _react.default.createElement(_MovingPage.default, props);
  };
}

module.exports = exports.default;